// Drill catalog for PA (Physical Architecture) and VI (Voice Integration) hubs.
// Each drill maps to a self-contained HTML file in /public/modules.

export const PA_DRILLS = [
  { id: 'root-rise', title: 'Root & Rise', desc: 'Feel the difference between light-footed and rooted, out loud.', file: 'pa-root-rise.html' },
  { id: 'conductors-arms', title: "The Conductor's Arms", desc: "Staccato lines or sweeping arcs — your arms set the tone's shape.", file: 'pa-conductors-arms.html' },
  { id: 'still-head', title: 'Still Head, Moving Mind', desc: 'Keep the head still, just imagine the movement, and listen for the leak.', file: 'pa-still-head.html' },
  { id: 'face-dial', title: 'Face Dial', desc: 'Think the expression instead of making it, and hear the voice shift anyway.', file: 'pa-face-dial.html' },
  { id: 'posture-audit', title: 'Daily Posture Audit', desc: 'A mirror check-in, zone by zone, before the voice has to do any work.', file: 'pa-posture-audit.html' },
  { id: 'eye-anchor', title: 'Eye Anchor', desc: 'A steady gaze vs. a darting one — hear which one sounds grounded.', file: 'pa-eye-anchor.html' },
  { id: 'chin-check', title: 'Chin Check', desc: 'Down, level, or up — three chin positions, three different messages.', file: 'pa-chin-check.html' },
  { id: 'hand-grip-dial', title: 'Hand Grip Dial', desc: 'Fingertips, palm, or wrist — your hands are already telegraphing your tone.', file: 'pa-hand-grip-dial.html' },
];

export const VI_DRILLS = [
  { id: 'listen-softer', title: 'Listen Softer', desc: 'Lower your volume by listening softer, not by straining to speak quiet.', file: 'vi-listen-softer.html' },
  { id: 'one-more-thing', title: 'One More Thing', desc: 'Suspicious or curious — the same question lands completely differently.', file: 'vi-one-more-thing.html' },
  { id: 'status-dial', title: 'Status Dial', desc: 'High, level, or low status — which reads calm-and-open versus clipped-and-closed.', file: 'vi-status-dial.html' },
  { id: 'good-food-good-chat', title: 'Good Food-Good Chat', desc: 'Taste is a shortcut to tone. Notice how your words change with it.', file: 'vi-good-food-good-chat.html' },
  { id: 'reappraise-pause', title: 'Reappraise Pause', desc: 'Two questions before you respond, to swap conflict for curiosity.', file: 'vi-reappraise-pause.html' },
];

// Primary VI modules — same tier as Tonal Influence and The Listening Chain.
export const AAA_CHECKLIST = {
  id: 'aaa-checklist',
  title: 'AAA Checklist',
  desc: 'Agency · Autonomy · Accountability — a three-beat pre-flight before any hard conversation.',
  file: 'vi-aaa-checklist.html',
};

export const FLASHCARDS = {
  id: 'flashcards-nudge',
  title: 'Flashcards & Daily Nudge',
  desc: 'One concept a day, or the whole deck — pulled from every drill.',
  file: 'fn-flashcards-nudge.html',
};
